import { createDownloadableLink } from '@/helpers';
import customToast from '@/new-components/CustomNotification';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  uploadMassUser:
    (data, callback) =>
    async ({ Api }) => {
      const { result, status } = await Api.post(
        `system-admins/user-imports`,
        data,
        '',
        undefined,
        true,
        true
      );
      if (status === 200) {
        customToast('success', 'Upload success');
        callback && callback();
        createDownloadableLink(result, `Mass-User`);
      }
    },

  downloadUserTemplate:
    () =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`system-admins/user-template`);
      if (status === 200) {
        createDownloadableLink(result, `Mass-User-Template`, 'csv');
      }
    },
};

const importMassUserDispatcher = synthesize('importMassUser', mapDispatchToAC);

export default importMassUserDispatcher;
